import React, { useContext, useEffect, useState } from 'react';
import './ProductDetails.css'
import Image from '../shared/Image';
import phoneImage from '../../public/image/phone.png'
import { priceFormat } from '../../util/showPriceFormat';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import { getProductInfo } from '../../service/productService';
import MainContext from '../../context/mainContext';
import LoadingBar from '../shared/EclipseLoading';
import config from './../../config.json';
import preview from './../../public/image/preview.png'
import socket from '../../service/socket';
import { charsNormalize } from '../../util/charactorsNormalize';
import { Helmet } from 'react-helmet';


const ProductDetails = () => {

    const { id: productId } = useParams();
    const { state } = useLocation();
    const [product, setProduct] = useState();
    const navigate = useNavigate();
    const context = useContext(MainContext);

    const [status, setStatus] = useState('disabled');
    const [count, setCount] = useState(1);

    useEffect(() => {
        if (!productId) {
            return navigate('/products', { replace: true })
        }
        if (state && state._id) {
            setProduct({ ...state })
        }
        else {
            const cancelRequest = requestCanceller();

            const fetchProductInfo = async () => {
                try {
                    let { status, data } = await getProductInfo(productId, { signal: cancelRequest.signal });
                    if (status === 201)
                        setProduct(data.product)
                } catch (err) {
                }
            }
            fetchProductInfo();
            return () => {
                cancelRequest.cancel();
            }

        }
    }, [productId, state, navigate])

    useEffect(() => {
        try {
            socket.on('product', data => {
                if ((data.action === 'update' || data.action === 'delete') && product._id === data.updatedProduct._id) {
                    navigate('.', { state: undefined, replace: true })
                }
            })
        } catch (err) { }
        return () => socket.off('product');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product])


    const countHandler = (eValue, operator) => {
        let data = {
            _id: product._id,
            name: product.name,
            price: product.price,
            image: product.image,
        }
        switch (operator) {
            case '+':
                if (status === 'enabled') {
                    context.addToShoppingCart({ ...data, count: count < 9999 ? count + 1 : count })
                    setCount(prev => prev + 1);
                }
                status === 'disabled' && setStatus('enabled');
                (count === 1 && status === 'disabled') && setStatus('enabled')
                break;
            case '-':
                if (count > 1) {
                    context.removeFromShoppingCart({ ...data, count: count - 1 })
                    setCount(prev => prev - 1);
                }
                if (count === 1 && status === 'enabled') {
                    context.removeFromShoppingCart({ ...data, count: count - 1 })
                    setStatus('disabled');
                }
                if (count === '' && status === 'enabled') {
                    setStatus('disabled');
                }
                break;
            case 'custom':
                if (status === 'enabled' && eValue) {
                    context.addToShoppingCart({ ...data, count: eValue })
                    setCount(eValue);
                }
                else if (status === 'enabled' && eValue === '') {
                    context.removeFromShoppingCart({ ...data, count: 0 })
                    setCount(eValue)
                }
                status === 'disabled' && setStatus('enabled');
                (count === 1 && status === 'disabled') && setStatus('enabled')
                break;
            default:
                break;
        }
    }

    const onSelectItemHandler = (event) => {
        let data = {
            _id: product._id,
            name: product.name,
            price: product.price,
            image: product.image,
        }
        setStatus('enabled');
        context.addToShoppingCart({ ...data, count: count ? count : 1 })

    }

    useEffect(() => {
        if (!product) {
            return;
        }
        context.shoppingCart.forEach(element => {
            if (element._id === product._id) {
                setStatus('enabled');
                setCount(element.count);
            }
        });
    }, [context.shoppingCart, product])

    const regix = /^[0-9\b]+$/;

    return (
        <React.Fragment>
            {
                product ?
                    <React.Fragment>
                        <header className='w-100 search-result mb-2'>
                            <Helmet>
                                <title>البرز مارکت | {product.name} | فروشگاه البرز</title>
                                <meta name="description" content={`${product.info} - ${"فروش عمده انواع قطعات کولر آبی و لوازم گازسوز و شیر آلات  | تولید کننده انواع دودکش های ساختمانی و ..."}`} />
                            </Helmet>
                            {
                                <h6>
                                    <span className='m-0'></span>
                                    <section className=' me-2 text-center' style={{ width: '40px', cursor: 'pointer' }}
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className='fa fa-arrow-right text-danger fs-5 '></i>
                                    </section>
                                    جزئیات کالا
                                </h6>
                            }
                        </header>
                        <div className='product-details-layer'>
                            <div className='image-section'>
                                <Image
                                    src={product.image ? `${config.api_address}/upload/${product.image}` : preview}
                                    width={window.innerWidth < 576 ? 200 : 250}
                                    height={window.innerWidth < 576 ? 200 : 250}
                                    borderRadius={'10px'}
                                    style={{ objectFit: 'cover', opacity: product.image ? '1' : '.5' }}
                                />
                            </div>
                            <div className='seperator d-none d-md-block'></div>
                            <div className='content col-12 col-md'>
                                <h5>{product.name}</h5>
                                <div>
                                    <span>کد محصول</span>
                                    <span className='mx-2'>:</span>
                                    <span className='text-muted'>{product.code}</span>
                                </div>
                                {
                                    (context.loggedIn && context.loggedIn.status === 'Enable') ?
                                        <div>
                                            <span>قیمت</span>
                                            <span className='mx-2'>:</span>
                                            <span className='text-success'>{priceFormat(product.price)} ریال</span>
                                        </div>
                                        :
                                        <div>
                                            <p style={{ textAlign: 'center' }} className='alert alert-warning m-0' role="alert">
                                                {
                                                    context.loggedIn ?
                                                        `برای مشاهده قیمت و ثبت سفارش باید عضویت شما تأیید شود`
                                                        :
                                                        <span>
                                                            برای مشاهده قیمت و ثبت سفارش ابتدا باید وارد {<Link className='alert-link' onClick={() => {
                                                                if (!context.loggedIn) {
                                                                    context.showLogin();
                                                                }
                                                            }}>
                                                                حساب کاربری</Link>} شوید
                                                        </span>
                                                }
                                            </p>
                                        </div>

                                }
                                {
                                    (context.loggedIn && context.loggedIn.isAdmin) &&
                                    <div className='d-flex'>
                                        <span>موجودی</span>
                                        <span className='mx-2'>:</span>
                                        <span className={`ltr ${Number(product.inventory) > 0 ? 'text-secondary' : 'text-danger'}`}>{product.inventory}</span>
                                    </div>
                                }
                                {
                                    product.info &&
                                    <div>توضیحات : {product.info}</div>
                                }
                                <div className="d-flex py-1 flex-row justify-content-start align-items-center alert alert-light">
                                    <Image
                                        src={phoneImage}
                                        width={38}
                                        height={33}
                                        borderRadius={'10px'}
                                    />
                                    <div className='ms-2'>مشاوره خرید</div>
                                    <div className='mx-2'>:</div>
                                    <div className=''>09055540128</div>
                                </div>
                                <div>
                                    {
                                        status === 'disabled' ?
                                            <button className='btn btn-lg btn-success'
                                                onClick={onSelectItemHandler}
                                                disabled={(!context.loggedIn || context.loggedIn.status !== 'Enable')}
                                            >
                                                <i className='fa fa-shopping-cart me-2'></i>
                                                افزودن به سبد خرید
                                            </button> :
                                            <div className="count-selection">
                                                <button
                                                    className='btn btn-success btn-lg'
                                                    onClick={e => countHandler(e, '+')}
                                                >
                                                    <i className="fa fa-plus"></i>
                                                </button>
                                                <div className='mx-2'>
                                                    <input
                                                    type='tel'
                                                        className='form-control ltr text-center'
                                                        value={count}
                                                        onChange={(e) => {
                                                            let normalized = '';
                                                            if (e.target.value) {
                                                                normalized = charsNormalize(e.target.value);
                                                            }
                                                            if (normalized === '' || (regix.test(Number(normalized)) && Number(normalized) > 0 && Number(normalized) <= 9999)) {
                                                                countHandler(normalized ? Number(normalized) : '', 'custom')
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <button
                                                    className='btn btn-danger btn-lg'
                                                    onClick={e => countHandler(e, '-')}
                                                >
                                                    <i className={`${(count <= 1) ? "fa fa-trash" : "fa fa-minus"}`}></i>
                                                </button>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    <section style={{
                        height: '60vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <LoadingBar classNames={`ldio-text-danger`} />

                    </section>


            }
        </React.Fragment>
    );
}

export default ProductDetails;